import { createAction, props } from '@ngrx/store';
import { ManagedFile } from '../../helperts/file.helper';

const SOURCE = '[Upload]';

export const startUpload = createAction(
  `${SOURCE} Start Upload`,
  props<{ file: ManagedFile; url: string }>()
);

export const uploadProgress = createAction(
  `${SOURCE} Upload Progress`,
  props<{ id: string; progress: number }>()
);

export const uploadSuccess = createAction(`${SOURCE} Upload Success`, props<{ id: string }>());

export const uploadFailure = createAction(
  `${SOURCE} Upload Failure`,
  props<{ id: string; error: unknown }>()
);

export const cancelUpload = createAction(`${SOURCE} Cancel Upload`, props<{ id: string }>());

export const clearUploads = createAction(`${SOURCE} Clear Uploads`);
